import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../context/AuthContext';
import heroVideo from '../../../assets/videos/video-profesionales.webm';
import styles from './HeroSection.module.scss';

export const HeroSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated, user } = useAuthContext();
    const isProfessional = isAuthenticated && user?.type_account === 'professional';
    const isConsultant = isAuthenticated && user?.type_account === 'patient';
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = true;
        }
    }, []);

    return (
        <section className={styles['hero']}>
            <video
                ref={videoRef}
                className={styles['hero__video']}
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={heroVideo} type="video/mp4" />
            </video>

            <div className={styles['hero__overlay']} />

            <div className={styles['hero__content']}>
                <div className={styles['hero__heading']}>
                    <h1 className={styles['hero__title']} data-no-animate>
                        <span>{t("landing.heroSection.titleLine1", "Potenciá tu práctica")}</span>
                        <span>{t("landing.heroSection.titleLine2", "sin perder tu esencia")}</span>
                    </h1>

                    <p className={styles['hero__sub']}>
                        {t("landing.heroSection.subheading", "Bodhiwell reúne a profesionales que comparten el deseo de acompañar a las personas desde una comprensión más amplia del bienestar, en un espacio donde distintas trayectorias y enfoques puedan encontrarse, dialogar y potenciarse.")}
                    </p>

                    <div className={styles['hero__cta-group']}>
                        {isProfessional ? (
                            <button
                                className={styles['hero__cta']}
                                onClick={() => navigate("/dashboard")}
                            >
                                {t("landing.heroSection.goDashboard", "Ir a mi panel")}
                            </button>
                        ) : isConsultant ? (
                            <button
                                className={styles['hero__cta']}
                                onClick={() => navigate("/contact")}
                            >
                                {t("landing.heroSection.ctaButton", "Quiero ser parte del equipo")}
                            </button>
                        ) : (
                            <button
                                className={styles['hero__cta']}
                                onClick={() => navigate("/register")}
                            >
                                {t("landing.heroSection.ctaButton", "Quiero ser parte del equipo")}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};